<template>
  <div class="component-form">
    <h1 class="form-title">Basic Information</h1>
    <p class="text mt-12">以下内容用中文填写即可</p>
    <div class="inp-flex mt-30">
      <div class="inp-wrap">
        <Input label="First name" :value="value.first_name" @input="handleInput($event, 'first_name')" />
      </div>
      <div class="inp-wrap">
        <Input label="Last name" :value="value.last_name" @input="handleInput($event, 'last_name')" />
      </div>
    </div>
    <div class="inp-flex mt-20">
      <div class="inp-wrap">
        <GenderSelect
          label="Gender"
          placeholder="Gender"
          :isVerific="false"
          :value="value.gender ? value.gender.toString() : value.gender"
          @input="handleInput($event, 'gender')"
        />
      </div>
    </div>
    <!-- <div class="inp-flex mt-20">
      <div class="inp-wrap">
        <TimeZoneSelect label="Time Zone" placeholder="Time Zone" :isVerific="false" :value="value.time_zone" @input="handleInput($event, 'time_zone')" />
      </div>
    </div> -->
    <div class="inp-flex mt-20">
      <div class="inp-wrap">
        <AreaCodeSelect
          label="Country code"
          placeholder="Country code"
          :isVerific="false"
          :value="value.phone_code"
          @input="handleInput($event, 'phone_code')"
        />
      </div>
      <div class="inp-wrap">
        <Input label="Phone number" :value="value.phone" @input="handleInput($event, 'phone')" />
      </div>
    </div>
    <div class="inp-flex mt-20">
      <div class="inp-wrap big">
        <Input label="Email" :value="value.email" @input="handleInput($event, 'email')" />
      </div>
    </div>
    <div class="inp-flex mt-20">
      <div class="inp-wrap big">
        <Input label="University" :value="value.university" @input="handleInput($event, 'university')" />
      </div>
    </div>
    <div class="inp-flex mt-30">
      <!-- <div class="inp-wrap">
        <Input label="Expected highest degree" :value="value.highest_degree" @input="handleInput($event, 'highest_degree')" />
      </div> -->
      <div class="inp-wrap">
        <Select
          label="Current grade"
          placeholder=""
          :isVerific="false"
          :startVerific="false"
          :value="value.grade"
          @input="handleInput($event, 'grade')"
          :options="GRADES"
        />
      </div>
    </div>
    <div class="inp-flex mt-20">
      <div class="inp-wrap big">
        <Input label="Current major" :value="value.current_major" @input="handleInput($event, 'current_major')" />
      </div>
    </div>
    <div class="inp-flex mt-20">
      <div class="inp-wrap large">
        <Textarea
          placeholder="Personal Introduction"
          :counter="false"
          :value="value.personal_introduction"
          @input="handleInput($event, 'personal_introduction')"
        />
      </div>
    </div>
    <p class="text mt-24">
      Please share details and stories including your second major if you have any, your special talent or things you do best, the
      organizations/departments/societies of Harvard where you take on an important role and the remarkable achievements you have made till now, the most
      difficult course/seminar you have ever attended at Harvard and you still got a grade A, the best off-campus internship experience you have had till now,
      some of your interesting hobbies, foreign languages that you can read/write/speak and any other stories that would surprise students.
    </p>
    <ImageUploader
      class="uploader-wrap mt-20"
      placeholder="Upload<br/>a profile photo"
      :value="value.profile_photo"
      @input="handleInput($event, 'profile_photo')"
      :role="ROLES.SL"
    />
    <div class="inp-wrap mt-20 large">
      <Input label="Official Seminar Title" :value="value.seminar_title" @input="handleInput($event, 'seminar_title')" />
    </div>
    <div class="inp-wrap mt-20 large">
      <Textarea
        :counter="false"
        placeholder="Official Seminar Description"
        :value="value.seminar_description"
        @input="handleInput($event, 'seminar_description')"
      />
    </div>
    <p class="text bold big mt-30">Seminar Track <span class="weak">Choose all that applies</span></p>
    <CheckboxGroup
      class="mt-10 checkboxgroup-wrap inp-wrap large"
      :options="GROUP_OPTIONS"
      :value="seminarTrack"
      @input="handleInputCheckGroup($event, 'seminar_track')"
    />
    <Button class="btn-submit" @click="handleClickSubmit">Submit</Button>
  </div>
</template>
<script>
import ROLES from '../../../../utils/roles';
import { Input, GenderSelect, AreaCodeSelect, Button } from '../../../../components/form';
import CheckboxGroup from '../../../../components/form/CheckboxGroup/Prototype';
import Textarea from '../../../../components/form/Textarea/Prototype';
import ImageUploader from '../../../../components/form/Uploader/ImageUploader';
import Select from '../../../../components/form/Select/select';
import GRADES from './grade';
const SCHOOL_OPTIONS = [
  {
    label: 'school1',
    value: 'school1'
  }
];
const CLASS_OPTIONS = [
  {
    label: 'class1',
    value: 'class1'
  }
];
const GROUP_OPTIONS = [
  {
    value: 'Natural Sciences',
    label: 'Natural Sciences'
  },
  {
    value: 'Social Sciences',
    label: 'Social Sciences'
  },
  {
    value: 'Arts and Humanities',
    label: 'Arts and Humanities'
  },
  {
    value: 'Business Management and Finance',
    label: 'Business Management and Finance'
  }
];
export default {
  name: 'BasicInfomation',
  components: {
    Input,
    GenderSelect,
    Select,
    // TimeZoneSelect,
    AreaCodeSelect,
    Textarea,
    ImageUploader,
    CheckboxGroup,
    Button
  },
  props: {
    value: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  computed: {
    GRADES() {
      return GRADES;
    },
    seminarTrack() {
      let ret = [];
      if (this.value && this.value.seminar_track && this.value.seminar_track.length) {
        ret = this.value.seminar_track.map(item => {
          return {
            label: item,
            value: item
          };
        });
      }
      return ret;
    },
    GROUP_OPTIONS() {
      return GROUP_OPTIONS;
    },
    ROLES() {
      return ROLES;
    },
    schoolData() {
      let ret = {
        areaId: [], // 学校 区域ID 顺序依次为 国家 省/州 城市
        schoolName: '', // 学校名称
        schoolId: '' // 学校ID
      };
      return ret;
    },
    SCHOOL_OPTIONS() {
      return SCHOOL_OPTIONS;
    },
    CLASS_OPTIONS() {
      return CLASS_OPTIONS;
    }
  },
  methods: {
    handleInputCheckGroup: function(value, name) {
      let valueData = [];
      valueData = value.map(item => {
        return item.value;
      });
      this.$emit('input', {
        ...this.value,
        [name]: valueData
      });
    },
    handleInput: function(value, name) {
      this.$emit('input', {
        ...this.value,
        [name]: value
      });
    },
    handleClickSubmit: function() {
      this.$emit('submit');
    }
  }
};
</script>
